import { Modal } from "antd"
import { L } from "@lib/abpUtility"
import "./modalCf.less"
interface ModalConfirmProps {
  onOk?: () => void
  onClose?: () => void
  markClosable?: boolean
  content?: any
  type?: "delete" | "confirm"
  title?: any
  okText?: any
  cancelText?: any
  cancelButtonProps?: any
  customBtns?: any
}

const modalConfirm = ({
  onOk,
  onClose,

  markClosable = false,
  content,
  okText = L("BTN_CONFIRM"),
  cancelText = L("BTN_CLOSE"),
  cancelButtonProps,
  title = <div className="flex column center-items">Delete record?</div>,

  customBtns = undefined,
}: ModalConfirmProps) => {
  Modal.confirm({
    title,
    content,
    maskClosable: markClosable,
    closable: false,
    onOk,
    onCancel: onClose,
    className: "custom-modal-confirm",
    okText: okText,
    cancelText: cancelText,

    icon: null,
    okButtonProps: { style: { display: !onOk ? "none" : "" } },
    cancelButtonProps: cancelButtonProps,
    footer: (_, { OkBtn, CancelBtn }) => (
      <>
        <CancelBtn />
        <OkBtn />
        {customBtns}
      </>
    ),
  })
}

export default modalConfirm
